import { ToastContent, ToastOptions, toast } from 'react-toastify';
import { dismissToast, setToastError, setToastSuccess, triggerToast } from './routines/toastRoutines';
import { takeEvery } from 'redux-saga/effects';

function* toastErrorSaga(action: any) {
    toast.error(action.payload);
    yield true;
}

function* toastSuccessSaga(action: any) {
    toast.success(action.payload);
    yield true;
}

function* dismissToastSaga() {
    toast.dismiss();
    yield true;
}

function* triggerToastSaga(action: { type: string; payload: { content: ToastContent; options: ToastOptions } }) {
    const { content, options } = action.payload;
    toast(content, options);
    yield true;
}

export default function* rootToastWatcher(): any {
    yield takeEvery(dismissToast.TRIGGER, dismissToastSaga);
    yield takeEvery(triggerToast.TRIGGER, triggerToastSaga);
    yield takeEvery(setToastError.TRIGGER, toastErrorSaga);
    yield takeEvery(setToastSuccess.TRIGGER, toastSuccessSaga);
}
